module.exports = __webpack_public_path__ + "treinamento-para-equipe.png?e40a8747ae9d10db007a29340b019b9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/treinamento-para-equipe.png
// module id = 231
// module chunks = 0